/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* keyedtimeout.ts
* 15-12-2019 - Jelmer Jellema - Spin in het Web B.V.
*/

/// <reference types="node" />

export class KeyedTimeout {
  private handles: Map<string, NodeJS.Timeout> = new Map();

  public set(key: string, callback: () => void, ms: number): void {
    this.clear(key); //weg
    this.handles.set(key, setTimeout(
      () => {
        //we zijn aan het runnen, dus weg ermee
        this.handles.delete(key);
        callback();
      }, ms));
  }

  public check(key: string) {
    return this.handles.has(key);
  }

  public clear(key: string) {
    let handle = this.handles.get(key);
    if (handle) {
      clearTimeout(handle);
      this.handles.delete(key);
    }
  }
}
